import {
  handleImageInput,
  withSBErrorHandling,
  type ImageInput,
  type OcrConfiguration,
  type PdfConfiguration,
} from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotPdfGeneratorImpl = {
  async generateFromImages(params: {
    images: ImageInput[];
    pdfConfiguration: PdfConfiguration;
    ocrConfiguration?: OcrConfiguration;
  }): Promise<string> {
    return withSBErrorHandling(async () => {
      return (
        await ScanbotSDKPlugin.generatePdfFromImages({
          ...params,
          images: handleImageInput(params.images),
        })
      ).result;
    });
  },

  async generateFromDocument(params: {
    documentUuid: string;
    pdfConfiguration: PdfConfiguration;
    ocrConfiguration?: OcrConfiguration;
  }): Promise<string> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.generatePdfFromDocument(params)).result;
    });
  },
};
